/**
 * @file: customerType.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { CustomerType } from '@euler/model/enum';
import { AbstractSearchCriterionProvider } from '../AbstractSearchCriterionProvider';
import { SearchCriterionOption } from '../types';

export class CustomerTypeCriterion extends AbstractSearchCriterionProvider<'customerType'> {
  static readonly shared = new CustomerTypeCriterion();

  constructor() {
    super('customerType');
  }

  getLabel(): string {
    return '客户类型';
  }

  internalGetDisplayText(value: CustomerType): string {
    return value === CustomerType.Default ? '私家车' : '单位车';
  }

  internalGetOptions(): SearchCriterionOption<CustomerType>[] {
    return [{ value: CustomerType.Default }, { value: CustomerType.Official }];
  }
}
